import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MenuService } from './modules/shared/services/menu.service';
import { UserService } from './modules/user/services/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent  {
  title = 'rendiciones-asach-ui';

  constructor(
    private menuService: MenuService,
    private userService: UserService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
  }


  ngOnInit() {
     if (isPlatformBrowser(this.platformId)) {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const payload = JSON.parse(atob(token.split('.')[1]));
          const role = payload.role;
          const userId = payload.id;
          this.menuService.setUserRole(role);
          this.userService.setUserRole(role);
          this.userService.setselectedUserId(userId);
        } catch (error) {
          console.error('Error al decodificar el token:', error);
        }
      } else {
        console.warn('No hay token en localStorage, desde app.component.ts');
      }
    }else{
      console.warn('No se está ejecutando en el navegador, desde app.component.ts');
    } 
  }
}

